import React from "react"

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
require('babel-polyfill')

//const stripePromise = loadStripe('pk_test_51Gs1TkE9yAnfWommdTHFod9E6y9ARCDN7JrXu38ZuImi8G9UJ6tM0WutM2aGSpBXwdHyEZdz68GfGbG8CKqZjC4b00VLGbRMQz');
const stripePromise = loadStripe('pk_live_fgeMwCcNU6Glu7b8cjUUhTsT00PcQ6eG04');

export const wrapRootElement = ({ element }) => {
  return (
    <Elements stripe={stripePromise}>
      {element} 
    </Elements>      
  )
}
